import { get } from '@/helpers/apiRequest';

export default {
  data() {
    return {
      items: [],
      loading: false,
      paginator: {},
      // Linha de filtros específicos fica recolhida: a busca do dia a dia é
      // rápida (termo + fabricante + origem) e o resto só atrapalharia a tela.
      filtrosAbertos: false,
    };
  },

  computed: {
    // O que está filtrando agora, já pronto para virar chip. Com catálogo
    // grande e duas origens, é fácil esquecer um filtro ligado e achar que
    // "sumiu registro" — os chips mostram e permitem tirar um a um.
    chipsFiltros() {
      return Object.entries(this.filtros || {})
        .filter(([, valor]) => valor !== '' && valor !== null && valor !== undefined)
        .map(([chave, valor]) => ({
          chave,
          rotulo: (this.rotulosFiltros || {})[chave] || chave,
          valor: this.descreverFiltro(chave, valor),
        }));
    },

    totalFiltrosAtivos() {
      return this.chipsFiltros.length;
    },
  },

  beforeMount() { this.load(); },

  methods: {
    load(page = 1) {
      this.loading = true;
      // Guarda de corrida: uma resposta lenta (ex.: carga de boot sem filtro)
      // não pode sobrescrever a listagem de uma busca disparada depois.
      const seq = (this._loadSeq = (this._loadSeq || 0) + 1);
      const params = this.buildListagemParams(page);
      get(`${this.listagemEndpoint}?${params}`)
        .then(json => {
          if (seq !== this._loadSeq) return;
          this.items = json.itens || json.data || json;
          if (json.paginator) this.paginator = json.paginator;
        })
        .finally(() => {
          if (seq === this._loadSeq) this.loading = false;
        });
    },

    buildListagemParams(page) {
      const params = new URLSearchParams({ page, sortBy: this.sort.by, sortType: this.sort.dir });
      // Origem do registro (integração). Fica fora do appendFiltros para valer
      // também nas telas que sobrescrevem os filtros, como a de bases.
      if (this.filtros && this.filtros.integracaoId) {
        params.append('integracao_id', this.filtros.integracaoId);
      }
      this.appendFiltros(params);
      return params;
    },

    // Trocar de fabricante muda as origens disponíveis: a que estava escolhida
    // sai da lista mas continuaria filtrando de forma invisível, então zera.
    onFabricanteChange() {
      this.filtros.integracaoId = '';
      this.load();
    },

    // Texto do chip. Sobrescreva no componente para traduzir id em nome (a tela
    // sabe o que carregou nos selects) e código em rótulo.
    descreverFiltro(chave, valor) {
      return valor;
    },

    // Encontra o texto da opção escolhida numa lista {id, nome}.
    nomeDaOpcao(lista, id) {
      const opcao = (lista || []).find((item) => String(item.id) === String(id));
      return opcao ? opcao.nome : id;
    },

    removerFiltro(chave) {
      this.filtros[chave] = '';
      this.load(1);
    },

    limparFiltros() {
      Object.keys(this.filtros).forEach((chave) => { this.filtros[chave] = ''; });
      this.load(1);
    },

    // Filtros padrão. Sobrescreva no componente para adicionar (ativo, codigo, etc).
    appendFiltros(params) {
      if (this.filtros.fabricanteId) params.append('fabricante_id', this.filtros.fabricanteId);
      if (this.filtros.termo) params.append('q', this.filtros.termo);
    },

    sortBy(column) {
      if (this.sort.by === column) {
        this.sort.dir = this.sort.dir === 'asc' ? 'desc' : 'asc';
      } else {
        this.sort.by = column;
        this.sort.dir = 'asc';
      }
      this.load(1);
    },
  },
};
